import React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import PropTypes from 'prop-types';
import I18n from '@utils/i18n';

function CommonSelect({ name, value, label, onChange, elements, placeholder }) {
  const ddListValue = () => {
    const elementLabel = elements.find((elem) => elem.value === value)?.label;

    if (value === undefined || value === '') return null;
    if (elementLabel === undefined) return onChange('');

    return {
      value,
      label: elementLabel
    };
  };

  const handleOnChange = (event) => {
    onChange(event.target.value.value);
  };

  const getPopupWidth = () => {
    if (!elements || elements.length === 0) return 'auto';

    const longestLabel = elements.reduce((max, elem) => {
      const popupLabel = elem.label || '';
      return popupLabel.length > max.length ? popupLabel : max;
    }, placeholder || '');

    // Estimate width (approximately 0.6rem per character + padding)
    const estimatedWidth = Math.max(16, longestLabel.length * 0.6 + 4);
    return `${estimatedWidth}rem`;
  };

  return (
    <>
      {label && (
        <label className="qmb-label" htmlFor={name}>
          {label}
        </label>
      )}
      <DropDownList
        id={name}
        className="qmb-popup"
        textField="label"
        dataItemKey="value"
        data={elements}
        value={ddListValue()}
        defaultItem={{
          label: placeholder,
          value: ''
        }}
        onChange={handleOnChange}
        popupSettings={{
          width: getPopupWidth()
        }}
      />
    </>
  );
}

export default CommonSelect;

CommonSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any
    })
  ).isRequired
};

CommonSelect.defaultProps = {
  label: undefined,
  onChange: null,
  placeholder: I18n.t('generic.all')
};
